import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import theme from '../../themes/main';
import { isIE } from '../../utils/helper';

export const InputContainer = styled.div`
  align-items: center;
  color: ${theme.palette.blueGrey};
  display: flex;
  font-weight: 300;
  justify-content: space-between;
  letter-spacing: 0.025em;
  margin: 0.625rem 0 1.25rem 0;
  width: 100%;

  & > label {
    flex: 0.5;
    display: flex;
    align-items: flex-start;

    & > span.required-mark {
      display: none;
    }
  }

  &.label-top {
    flex-direction: column;

    & > label {
      text-align: left;
      max-width: 500px;
      ${() => isIE() ? `margin-bottom: 1.5rem;` :`margin-bottom: 0.5rem;`}
      width: 100%;

      & > span.required-mark {
        color: ${theme.palette.red};
        display: block;
        margin-left: 0.2rem;
      }
    }

    & > div {
      align-items: flex-start;
      flex-direction: column;
      margin: 0;
      width: 100%;
      max-width: 500px;

      & > input {
        max-width: initial;
        width: calc(100% - 28px);
      }
    }
  }
`;

const InputStyles = css`
  display: block;
  margin: 0;
  max-width: 500px;
  padding: 10px 14px;
  font-size: 1em;
  outline: 0;
  box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
  -moz-box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
  -webkit-box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
  border: 0;
  border-radius: 4px;
  background: white;
  -webkit-appearance: none;

  &::placeholder {
    color: ${theme.palette.lightBlueGrey};
  }
  &:focus {
    box-shadow: rgba(50, 50, 93, 0.109804) 0px 4px 6px, rgba(0, 0, 0, 0.0784314) 0px 1px 3px;
    -webkit-transition: all 150ms ease;
    transition: all 150ms ease;
  }
`

export const Input = styled.input`
  ${InputStyles}
  max-height: 38px;
  max-width: 140px;
  width: auto;

  ${breakpoint('tablet')`
    max-width: 500px;
  `}
`;

export const Textarea = styled.textarea`
  ${InputStyles}
  overflow: auto;
  width: calc(100% - 28px);
`;

export const ErrorText = styled.span`
  color: ${theme.palette.red};
  font-size: 0.75rem;
  margin-top: 8px;
`;

export const InnerContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  ${() => isIE() ? `margin: 0 0 0 30px;` : `margin: 0 0 0 10px;`}
  flex: 1;

  &.label-top {
    flex: inherit;
  }
`;



// WEBPACK FOOTER //
// ./src/components/RyderInput/styledComponents.js